/* ==========================================================================
   DOPPIO Prevádzka — štítok otvorené/zatvorené + galéria
   Sekcia: doppio-prevadzka.liquid
   ========================================================================== */

(function () {
  'use strict';

  var TZ = 'Europe/Bratislava';

  /* ------------------------------------------------------------------------
     Štítok otvorené / zatvorené

     Server vykreslí neutrálny záložný text a až prehliadač ho nahradí
     konkrétnym stavom. Keby stav rátal Liquid, cache by ho zamrazila a na
     stránke by v nedeľu svietilo "Otvorené do 20:00".
     ---------------------------------------------------------------------- */

  /** "7:00 – 20:00" -> { open: 420, close: 1200 }; null pri zatvorenom. */
  function parseRange(raw) {
    if (!raw) return null;
    var value = String(raw).trim();
    if (!value) return null;
    // "Zatvorené" aj s diakritikou v ľubovoľnom tvare
    if (value.toLowerCase().indexOf('atvoren') !== -1) return null;

    var parts = value.replace(/[–—]/g, '-').split('-');
    if (parts.length !== 2) return null;

    var open = toMinutes(parts[0]);
    var close = toMinutes(parts[1]);
    if (open === null || close === null) return null;

    return { open: open, close: close, openLabel: format(open), closeLabel: format(close) };
  }

  function toMinutes(text) {
    var match = String(text).trim().match(/^(\d{1,2})[:.](\d{2})$/);
    if (!match) return null;
    var hours = parseInt(match[1], 10);
    var minutes = parseInt(match[2], 10);
    if (hours > 23 || minutes > 59) return null;
    return hours * 60 + minutes;
  }

  function format(minutes) {
    var h = Math.floor(minutes / 60);
    var m = minutes % 60;
    return h + ':' + (m < 10 ? '0' + m : m);
  }

  /** Aktuálny deň a čas v čase prevádzky, nie v čase návštevníka. */
  function nowInShopTz() {
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: TZ,
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).formatToParts(new Date());
    } catch (e) {
      return null;
    }

    var out = {};
    parts.forEach(function (part) {
      out[part.type] = part.value;
    });
    if (!out.weekday || !out.hour || !out.minute) return null;

    return {
      weekday: out.weekday,
      minutes: parseInt(out.hour, 10) * 60 + parseInt(out.minute, 10)
    };
  }

  function rangeForToday(el, weekday) {
    if (weekday === 'Sat') return parseRange(el.getAttribute('data-hours-saturday'));
    if (weekday === 'Sun') return parseRange(el.getAttribute('data-hours-sunday'));
    return parseRange(el.getAttribute('data-hours-weekday'));
  }

  function renderStatus(el) {
    var now = nowInShopTz();
    if (!now) return;

    var range = rangeForToday(el, now.weekday);

    if (!range) {
      el.textContent = 'Dnes zatvorené';
      el.classList.add('is-closed');
      return;
    }

    if (now.minutes < range.open) {
      el.textContent = 'Otvárame o ' + range.openLabel;
      el.classList.add('is-closed');
      return;
    }

    if (now.minutes >= range.close) {
      el.textContent = 'Dnes zatvorené';
      el.classList.add('is-closed');
      return;
    }

    el.textContent = 'Otvorené do ' + range.closeLabel;
    el.classList.remove('is-closed');
  }

  /* ------------------------------------------------------------------------
     Galéria
     ---------------------------------------------------------------------- */
  function initGallery(root) {
    var slides = root.querySelectorAll('[data-gallery-slide]');
    if (slides.length < 2) return;

    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    var counter = root.querySelector('[data-gallery-counter]');
    var index = 0;

    function show(target) {
      index = (target + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i++) {
        var isActive = i === index;
        slides[i].classList.toggle('is-active', isActive);
        if (isActive) {
          slides[i].removeAttribute('aria-hidden');
        } else {
          slides[i].setAttribute('aria-hidden', 'true');
        }
      }
      if (counter) counter.textContent = index + 1 + ' / ' + slides.length;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        show(index - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        show(index + 1);
      });
    }

    show(0);
  }

  /* ------------------------------------------------------------------------
     Štart
     ---------------------------------------------------------------------- */
  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-doppio-status]').forEach(renderStatus);
    root.querySelectorAll('[data-doppio-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor prekresľuje sekcie bez reloadu stránky.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
